import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormControl,
} from '@angular/forms';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { takeUntil, combineLatest, Subject } from 'rxjs';

@Component({
    selector: 'user-other-nationalities',
    templateUrl: './user-other-nationalities.component.html',
    styleUrls: ['./user-other-nationalities.component.scss'],
    standalone: false
})
export class UserOtherNationalitiesComponent
  implements OnInit, OnChanges, AfterViewInit
{
  userOtherNationalities: UntypedFormArray;

  @Input() submitted: boolean;

  @Input() derrors: any = false;
  doneSubject: Subject<void> = new Subject<void>();
  subscriptions: any[] = [];
  countries: any[];
  departments: any[];
  destroy$ = new Subject<void>();
  constructor(
    private controlContainer: ControlContainer,
    private cd: ChangeDetectorRef,
    private referenceDao: ReferenceDao,
  ) {}
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  ngOnInit() {
    this.userOtherNationalities = this.controlContainer
      .control as UntypedFormArray;

    const combineLatestObservable = combineLatest([
      this.referenceDao.getCountries(),
      this.referenceDao.getDepartment(),
    ]);

    combineLatestObservable
      .pipe(takeUntil(this.destroy$))
      .subscribe(([countries, departments]) => {
        this.countries = countries;
        this.departments = departments;
      });
  }

  addFields() {
    if (this.userOtherNationalities.valid) {
      this.userOtherNationalities.push(new UntypedFormControl(''));

      this.userOtherNationalities.markAsUntouched();
      this.userOtherNationalities.markAsDirty();
    } else {
      this.userOtherNationalities.markAllAsTouched();
    }
  }

  deleteFields(index) {
    this.userOtherNationalities.removeAt(index);

    this.userOtherNationalities.markAsDirty();
  }

  ngOnChanges() {
    if (this.userOtherNationalities)
      this.userOtherNationalities.controls.forEach(control => {
        control.setValidators([]);
        control.updateValueAndValidity();
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
